import { StepperOrientation } from '@angular/cdk/stepper';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IAngularMyDpOptions } from 'angular-mydatepicker';
import { CreditCardService, PaymentService, ErrorHandlerService, ValidDatePipe, ViewportService, CommonSettings } from 'epay-library';
import { IScheduledDay } from 'epay-library/lib/features/common/models/payment/scheduledday';
import { IScheduledFrequency } from 'epay-library/lib/features/common/models/payment/scheduledfrequency';
import { IEMPPaymentList } from 'epay-library/lib/features/employer/models/payment/achd/employerPaymentList';
import { IEMPCCPayment } from 'epay-library/lib/features/employer/models/payment/creditcard/employerCCPayment';
import { IEMPPaymentCollection } from 'epay-library/lib/features/employer/models/payment/employerPaymentCollection';
import * as XLSX from 'xlsx';

const PayorValidationTypes = {
  scheduldedPayment: 'scheduledPayment',
  creditCard: 'creditCard',
  eftEdiFile: 'eftEdiFile',
};

type AOA = any[][];
enum PreviousPayorsType {
  ALL_PAYORS,
  PREVIOUS_PAYORS,
  NONE,
}

@Component({
  selector: 'emp-cc-payment-common',
  templateUrl: './empccpayment-common.component.html'
})
export class EMPCCPaymentCommonComponent implements OnInit {
  @Input() baseurl = '';
  @Input() secondaryIdAlias = '';
  @Input() termsContent = '';
  @Input() creditCardVendorId = 0;
  @Input() creditCardDisclaimer = '';
  @Input() validateCaseNumber = false;
  @Input() allowZeroAmount = false;
  @Input() clientName = '';

  @ViewChild('LastName', { static: false }) nameField!: ElementRef;
  @ViewChild('inputFile', { static: false }) inputFile!: ElementRef;

  data: any;
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  payorChkType = PreviousPayorsType.NONE;
  currentlyChecked = PreviousPayorsType.NONE;

  validationType = '';

  employerEIN = '';

  stepperOrientation: StepperOrientation = 'horizontal';

  termsFrmGp: FormGroup = new FormGroup({});
  reviewFrmGrp: FormGroup = new FormGroup({});
  paymentcollectionFrmGp: FormGroup = new FormGroup({});
  paymentCollection: IEMPPaymentCollection[];
  paymentheader: string[] = [
    'Name',
    'SSN',
    'Case Number',
    'Amount',
    'Action',
    'Validation',
  ];
  empCCPayment: IEMPCCPayment = {} as IEMPCCPayment;
  scheduledFrequencies: IScheduledFrequency[];
  scheduledDaysWeek: IScheduledDay[];
  scheduledDaysBiMonth: IScheduledDay[];
  scheduledDaysMonth: IScheduledDay[];
  scheduledDays: IScheduledDay[];
  scheduledpayments: IEMPPaymentList[] = [];

  today = new Date();
  maxDate = new Date();
  minDate = new Date();

  transactionId = '';

  ssnHide = true;
  startDate = '';
  showPaymentCollectionForm: boolean;
  numOfPayments = 0;
  totalAmtOfPayments = 0;
  numInvalid = 0;
  numWarning = 0;
  iseditccPayment = false;
  iseditccPaymentCollection = false;
  editccPaymentCollectionIndex: number;
  errorMessage = '';
  validationErrorMessage = '';
  showScheduleDay: boolean;
  selectedFrequency = '';
  selectedFrequencyCode = '';
  selectedDay = '';
  selectedDayCode = '';
  nextScheduledDate = '';
  noPreviousPayors = '';
  isLoadingPreviousPayors = false;

  scheduleddayCtrl: any;

  confirmationSender = '';
  confirmationTitle = '';
  confirmationMessage = '';
  confirmationNumber = '';
  goToPrimary = '';
  goToPrimaryUrl = '';
  openConfirmation = false;
  isLoadingEdit = false;
  isTermsSubmitted = false;
  allChecked = false;

  animateInput = false;
  atLeastOnePayorSelected = false;
  validateAttemptMade = false;
  insertUpdateError = false;
  nameChangeOccured = false;
  insertUpdateErrorMessage = '';
  isBankAccountSelected = false;

  fileImportHint = `File must contain 4 columns with headers titled "Last Name", "SSN", "Case Number", "Amount"`;
  fileErrorMessage = '';
  payorDetailError = '';
  calendarHint = '';

  toggleEditPayor = false;
  toggleImportPayor = false;

  currencyPattern = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
  ssnPattern = /^(?!000|666)[0-9]{3}([ -]?)(?!00)[0-9]{2}\1(?!0000)[0-9]{4}$/;

  // Datepicker settings
  dateSettingsOptions: IAngularMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    firstDayOfWeek: 'su',
    closeSelectorOnDateSelect: true,
    sunHighlight: false,
    disableWeekends: true,
    disableUntil: {
      year: 0,
      month: 0,
      day: 0,
    },
  };
  constructor(
    private formbuilder: FormBuilder,
    private creditCardService: CreditCardService,
    private paymentService: PaymentService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private validDatePipe: ValidDatePipe,
    public snackbar: MatSnackBar,
    private viewpointService: ViewportService
  ) {
    this.iseditccPaymentCollection = false;
    this.showPaymentCollectionForm = false;
    this.showScheduleDay = false;
    this.paymentCollection = [];
    this.scheduledDaysWeek = [];
    this.scheduledDaysBiMonth = [];
    this.scheduledDaysMonth = [];
    this.scheduledDays = [];
    this.scheduledFrequencies = [];
    this.editccPaymentCollectionIndex = -1;
    this.maxDate.setDate(
      this.today.getDate() + +CommonSettings.NumOfDaysOutForCalendar
    );
  }

  ngOnInit() {
    this.validationType = PayorValidationTypes.creditCard;
    this.loadFormGroups();

    if (this.secondaryIdAlias !== '') {
      this.paymentheader = [
        'Name',
        'SSN',
        this.secondaryIdAlias,
        'Amount',
        'Action',
        'Validation',
      ];
    } else {
      this.secondaryIdAlias = 'Case Number';
    }

    this.viewpointService.StepperOrient.subscribe(
      (orient) => (this.stepperOrientation = orient)
    );
  }

  validCCPaymentEmitted(ccPayment: any) {
    this.empCCPayment = ccPayment.creditCardPayment;
    this.paymentCollection = this.empCCPayment.participantCollection;
    this.getNumberOfPayments();
  }

  toggleSSNHide() {
    this.ssnHide = !this.ssnHide;
  }

  toggleEditPayorTab() {
    this.toggleEditPayor = true;
  }

  resetToggle() {
    this.toggleEditPayor = false;
  }

  getNumberOfPayments(): number {
    this.numOfPayments = 0;
    this.totalAmtOfPayments = 0;
    this.atLeastOnePayorSelected = false;
    this.paymentCollection.forEach((element) => {
      if (element.isSelected) {
        this.atLeastOnePayorSelected = true;
        this.numOfPayments++;
        this.totalAmtOfPayments += +element.amount;
      }
    });
    this.totalAmtOfPayments = +this.totalAmtOfPayments.toFixed(2);
    return this.numOfPayments;
  }

  loadFormGroups() {
    this.termsFrmGp = this.formbuilder.group({
      accepted: ['', Validators.requiredTrue],
    });

    this.reviewFrmGrp = this.formbuilder.group({});
  }

  resetFormValues() {
    this.termsFrmGp.setValue({
      accepted: false,
    });
  }

  checkReading() {}

  editccPaymentcollection(ccPayment: IEMPPaymentCollection, index: number) {
    // this.nameField.nativeElement.focus();
    // this.iseditccPaymentCollection = true;
    // this.editccPaymentCollectionIndex = index;
    // this.paymentFrmGp.reset();
    // this.paymentFrmGp.get('collectionFrmGp')!.patchValue({
    //   lastname: ccPayment.lastName,
    //   ssn: ccPayment.ssn,
    //   casenumber: ccPayment.caseNumber,
    //   amount: ccPayment.amount,
    // });
    // this.paymentFrmGp.updateValueAndValidity();
    // this.numInvalid = 0;
    // this.numWarning = 0;
    // this.paymentsValid = false;
    // this.paymentCollection.forEach((payor) => {
    //   payor.isValidated = false;
    //   payor.hadEdit = false;
    // });
  }

  onSaveComplete(confirmationNum: string) {
    this.termsFrmGp.reset();
    this.reviewFrmGrp.reset();

    this.confirmationSender = 'Create A New Payment';
    this.confirmationTitle = 'Success';
    this.confirmationMessage = this.iseditccPayment
      ? 'Your scheduled Credit Card Payment has been updated!'
      : 'New scheduled Credit Card Payment has been created!';
    this.confirmationNumber = confirmationNum;
    this.goToPrimaryUrl = 'employer/achd/landing';
    this.goToPrimary = 'ACH Debit Home';
    this.openConfirmation = true;
  }

  hideConfirmationPage(result: any) {
    this.termsFrmGp.reset();
    this.reviewFrmGrp.reset();

    this.resetFormValues();

    this.isTermsSubmitted = false;
    this.iseditccPaymentCollection = false;
    this.showPaymentCollectionForm = false;
    this.showScheduleDay = false;
    this.paymentCollection = [];

    this.loadFormGroups();
    this.openConfirmation = !result.hideConfirmation;
  }

  goToHome() {
    this.router.navigateByUrl('employer/home');
  }

  openSnackBar(message: string, time: number, style: string) {
    const config = new MatSnackBarConfig();
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = time;
    config.panelClass = style;
    this.snackbar.open(message, '', config);
  }

  submitTerms() {
    this.isTermsSubmitted = true;
  }
  logError(error: Error) {
    this.errorHandlerService.logError(error);
  }

  handleError(error: number) {
    console.log(this.errorMessage);
    console.log('error', error);
    this.errorHandlerService.handleErrorMessage(error, this.baseurl);
  }
}

